import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addSubject } from "../../store/slices/subject";
import { toast } from "react-hot-toast";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

export default function AddSubject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};


    if (!name.trim()) {
      newErrors.name = "Please enter subject name";
    } else if (!/^[A-Za-z\s]+$/.test(name)) {
      newErrors.name =
        "Subject name should contain only letters and spaces";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;


  };

  const handleSubmit = (e) => {
    e.preventDefault();


    if (!validate()) return;

    const payload = {
      name: name.trim(),
    };

    dispatch(addSubject(payload))
      .unwrap()
      .then(() => {
        toast.success("Subject added successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err || "Failed to add subject");
      });


  };

  const handleNameChange = (e) => {
    const value = e.target.value;


    // Allow only alphabets and spaces
    if (/^[A-Za-z\s]*$/.test(value)) {
      setName(value);

      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.name;
        return newErrors;
      });
    }


  };

  return (
    <> <div className="page-header"> <div className="breadcrumb-section">


      <div className="breadcrumb-left">
        <div className="home-icon">
          <Link to="/institute/home">
            <FiHome
              style={{
                color: "white",
                marginTop: "-4px",
              }}
            />
          </Link>
        </div>

        <FiChevronRight className="separator" />

        <Link to="/institute/subjects">
          Subjects
        </Link>

        <FiChevronRight className="separator" />

        <span className="active">
          Add Subject
        </span>
      </div>
    </div>
    </div>

      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">

            <Col md={3} sm={12}>
              <Form.Group>

                <Form.Label>Subject</Form.Label>

                <Form.Control
                  value={name}
                  maxLength={20}
                  placeholder="Enter subject"
                  onChange={handleNameChange}
                />

                {errors.name && (
                  <small className="text-danger">
                    {errors.name}
                  </small>
                )}

              </Form.Group>
            </Col>

          </Row>

          <div className="sa-actions mt-5">

            <button
              type="button"
              className="btn-cancel"
              style={{ color: "black" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn-submit"
            >
              Submit
            </button>

          </div>

        </Form>
      </div>
    </>


  );
}
